// Modules
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import uuid from "react-uuid";

// CSS
import '_Asset/css/Admin/Page/admin.css'

// API
import { AdNewsApi, AdNewsUploadApi, AdNewsCatApi, AdNewsSgApi } from "_Route/Api";
import { uploadPlugin } from "Admin/Component/AdFunc";
import DefaultCKEditor from "Admin/Component/DefaultCKEditor";


const AdNewsDt = () => {

  // Using Hooks
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [guideStatus, setGuideStatus] = useState(true);
  const sessionID = localStorage.getItem('memSessionID')
  const userName = useSelector(state => state.authorityAcc.name);
  const userScore = useSelector(state => state.authorityAcc.access_score);
  const master = useSelector(state => state.authorityAcc.master);
  const imgHost = process.env.REACT_APP_IMG_HOST;

  // State
  const curType = params.id === 'add' ? '등록' : '수정'; // 관리 Type
  const curScore = params.id === 'add' ? 200 : 300; // 현재 타입에 따른 필요 권한 점수
  const useGroup = ['미사용', '사용']; // 사용 여부 배열
  
  
  const [catList, setCatList] = useState([]);
  const [catValue, setCatValue] = useState();
  const curDate = moment(new Date()).format('YYYY-MM-DD HH:mm'); // 현재 날짜 및 시간
  
  const [info, setInfo] = useState({ // 전체 Input Data 배열 
    news_use: 1,
    news_title: '',
    news_content: undefined,
    news_category: '2',
    news_tag: '',
    news_cat: '',
    news_create_user: userName,
    news_lang: 'ko',
    news_file: undefined,
    news_dfile: undefined,
    approve_spec_status: 0,
    approve_ap_status: 0,
  })
  const [fileName, setFileName] = useState([]); // 추가된 모든 Image Array
  const [tagName, setTagName] = useState(''); 
  const [tagList, setTagList] = useState([]); 
  const { news_use, news_title, news_content, news_category, news_lang, news_tag, news_cat } = info;

  const newsTab = [
    {name: '한글 뉴스', value: 'ko'},
    {name: '영문 뉴스', value: 'en'},
  ]
  

  /*========================================================================
  * Input onChange Func
  ========================================================================*/
  // onChange Info
  const onChange = (e) => {
    const { name, value } = e.target;
    setInfo({...info, [name]: value});
  }

  // onChange Info - Image URL
  const onChangeFile = () => {
    let fnFileArr = [] // 마지막 남은 Image Array
    fileName.map(list => {
      if (news_content.includes(list)) {
        fnFileArr.push(list)
      }
    })

    // 삭제된 Image Array
    const dfile = fileName.filter(it => !fnFileArr.includes(it))
    setInfo({
      ...info,
      news_file: fnFileArr.length !== 0 ? fnFileArr : undefined,
      news_dfile: dfile.length !== 0 ? dfile : undefined,
    })
  }

  // Tag 추가 Function
  const onKeyPress = (e) => { if(e.key == 'Enter') addTag(); }
  const addTag = () => {

    const tagArr = tagName.split(',');
    tagArr.map((tag, i) => {
      tagArr[i] = '#' + tag.trim()
    })
    
    if(tagArr.length + tagList.length > 5) {
      alert("태그는 최대 5개까지 입력할 수 있습니다.")
    }
    else if (tagName === '') {
      alert("태그를 입력해주세요.")
    }
    else if (tagList.includes('#' + tagName.trim()) || tagArr.filter(x => tagList.includes(x)).length > 0) {
      alert("입력한 태그명이 이미 존재합니다.")
    }
     else {
      if(tagArr.length >= 2) { // , 다중 입력 체크
        const set = new Set(tagArr);
        if (set.size < tagArr.length) { // 중복 태그가 존재하는지 체크
          alert("중복된 태그명이 존재합니다.")
        } else {
          tagArr.map(tag => { // 다중 입력 태그 저장
            setTagList(prevList => [...prevList, tag])
          })
        }
      } else { // 단일 입력 태그 저장
        setTagList(prevList => [...prevList, '#' + tagName.trim()]);
      }
      setTagName('');
    }
  }

  useEffect(() => {
    setInfo({...info, news_tag: tagList.length === 0 ? '' : tagList})
  }, [tagList])


  /*========================================================================
  * Set Current News List
  ========================================================================*/
  useEffect(() => {
    axios.get(AdNewsCatApi, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
    })
    .then(res => {
      setCatList(res.data.result)
    })
    .catch(err => {
      console.error(err, "GET News Category List Error...");
    })

    axios.get(AdNewsSgApi, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      params: {
        news_uuid: params.id
      }
    })
    .then(res => {
      // console.log(res,"res")
      const curNews = res.data.result
      if(curNews === undefined && params.id !== 'add') {
        navigate('/404');
      }

      if(curType === '수정') {
        setCatValue(curNews.news_category);

        if(curNews.news_file) {
          setFileName(JSON.parse(curNews.news_file));
        }
        if(curNews.news_tag.length >= 1) {
          setTagList(JSON.parse(curNews.news_tag))
        }
      }
      setInfo({
        news_use: curType === '수정' ? curNews.news_use : 1,
        news_title: curType === '수정' ? curNews.news_title : '',
        news_content: curType === '수정' ? curNews.news_content : undefined,
        news_category: curType === '수정' ? curNews.news_category : '2',
        news_tag: curType === '수정' ? curNews.news_tag : '',
        news_cat: '',
        news_create_user: userName,
        news_lang: curType === '수정' ? curNews.news_lang : 'ko',
        news_file: curType === '수정' && curNews.news_file ? JSON.parse(curNews.news_file) : undefined,
        news_dfile: undefined,
        approve_spec_status: 0,
        approve_ap_status: 0,
      })
    })
    .catch(err => {
      console.error(err, "GET News Data Error...");
    })
  }, [location])


  /*========================================================================
  * News Axios 
  ========================================================================*/
  const NewsConfirm = () => {
    if (news_category === '1' && news_cat === '') { alert("사용할 카테고리명을 입력해주세요.") }
    else if (news_tag === '' || news_tag.length === 0) { alert("사용할 태그를 추가해주세요.") }
    else if (news_title === '') { alert("제목을 입력해주세요.") }
    else if (news_content === '') { alert("내용을 입력해주세요.") }
    else {
      if (curType === '수정') { updateNews() }
      else { postNews() }
    }
  }
  
  const postNews = () => { // News 등록
    axios({
      url: AdNewsApi,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: info
    })
    .then(res => {
      alert(`News 등록${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
      navigate('/admin/news/list')
    })
    .catch(err => {
      // alert(err.response.data.result)
      console.error(err, `News POST Error..`)
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }

  const updateNews = () => { // News 수정
    const tempInfo = info;
    tempInfo.news_uuid = params.id

    axios({
      url: AdNewsApi,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: tempInfo
    })
    .then(res => {
      alert(`News 수정${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
      navigate('/admin/news/list')
    })
    .catch(err => {
      console.error(err, "News PUT Error..")
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }

  const deleteNews = () => { // News 삭제
    axios({
      url: AdNewsApi,
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        news_uuid: params.id,
        approve_spec_status: 0,
        approve_ap_status: 0,
      }
    })
    .then(res => {
      alert(`News 삭제${master === 1 ? '를' : ' 요청을'} 완료하였습니다.`)
      navigate('/admin/news/list')
    })
    .catch(err => {
      console.error(err, "News DELETE Error..")
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }
  
  
  return (
    <>
      <div className="adContTitGroup">
        <h2>News {curType}</h2>
        <p>Home / News / News {curType} <button type="button" onClick={() => setGuideStatus(!guideStatus)}><i className="icofont-info-circle" /> 가이드 {guideStatus ? '접기' : '보기'} <i className={`icofont-rounded-${guideStatus ? 'up' : 'down'}`} /></button></p>

        <ul className={`subMsg ${guideStatus ? '' : 'off'}`}>
          <li>* 태그 추가시 ,로 구분하여 <span className="blueTxt">일괄 추가가 가능</span>합니다.</li>
        </ul>
      </div>

      <div className="adContArea detail">
        <fieldset className="left">
          <legend>News 글 수정</legend>

          {/* 사용여부 [news_use] */}
          <div className="fieldGroup row">
            <label>사용여부<span className="redTxt">*</span></label>

            <div className="field">
              {useGroup.map((item, i) =>
                <div className="checkGroup" key={i}>
                  <input type="radio" className="check sm blue" name="news_use" id={`news_use_${i}`} value={i} onChange={(e) => onChange(e)} checked={Number(news_use) === i}/>
                  <label htmlFor={`news_use_${i}`}></label>

                  <label htmlFor={`news_use_${i}`}>{item}</label>
                </div>
              )}
            </div>
          </div>

          {/* 언어 [news_lang] */}
          <div className="fieldGroup row">
            <label>언어<span className="redTxt">*</span></label>

            <div className="field">
              <div className="tabList">
                {newsTab.map((key, i) => 
                  <button key={i} type="button" className={`btn xs ${news_lang === key.value ? 'sfrtBlue' : 'blue_edge'} round_10`} name="news_lang" value={key.value} onClick={(e) => onChange(e)}>{key.name}</button>
                )}
              </div>
            </div>
          </div>

          {/* 카테고리 [news_category] */}
          <div className="fieldGroup row">
            <label>카테고리<span className="redTxt">*</span></label>

            <div className="field gap">
              <select className="select md round_10 type_1" name="news_category" onChange={(e) => {onChange(e); setCatValue(e.target.value)}} key={uuid()} defaultValue={curType === '등록' ? news_category : catValue}>
                {catList.map((list, i) =>
                  <option value={list.newscat_no} key={i}>{list.news_cat}</option>
                )}
              </select>
              
              { news_category === "1" &&
                <input type="text" className="input md round_10" name="news_cat" onChange={(e) => onChange(e)} value={news_cat} placeholder="사용할 카테고리를 입력해주세요." />
              }
            </div>
          </div>

          {/* 태그 [news_tag] */}
          <div className="fieldGroup row">
            <label>태그<span className="redTxt">*</span></label>

            <div className="field gap">
              <input type="text" className="input md round_10" name="news_tag" onChange={(e) => setTagName(e.target.value)} onKeyPress={(e) => onKeyPress(e)} value={tagName} placeholder="추가할 태그를 입력해주세요." disabled={tagList.length > 4 ? true : false} />
              <button type="button" className="btn sm round_10 sfrtBlue" onClick={() => addTag()}>태그 추가</button>
              {tagList.length > 0 &&
                <div className="tagList">
                  {tagList.map((list, i) =>
                    <p key={i}>{list}<button type="button" className="icofont-error" onClick={() => setTagList(tagList.filter((key, index) => i !== index))}></button></p>
                  )}
                </div>
              }
            </div>

          </div>

          {/* 제목 [news_title] */}
          <div className="fieldGroup row">
            <label>제목<span className="redTxt">*</span></label>

            <div className="field full">
              <input type="text" className="input md round_10" name="news_title" onChange={(e) => onChange(e)} value={news_title} placeholder="제목을 입력해주세요." />
            </div>
          </div>

          {/* 내용 [news_content] */}
          <div className="fieldGroup row">
            <label>내용<span className="redTxt">*</span></label>

            <div className="field full">
              <DefaultCKEditor
                config={{placeholder: "내용을 입력하세요."}}
                data={news_content}
                onReady={(editor) => {
                  uploadPlugin(editor, AdNewsUploadApi, setFileName, 'news')
                }}
                onChange={(event, editor) => {
                  {(news_content || news_content === "" || curType === "등록") &&
                  setInfo({
                    ...info,
                    news_content: editor.getData()
                  })}
                }}
                onBlur={() => onChangeFile()}
              />
            </div>
          </div>

          {/* 작성/수정자 */}
          <div className="fieldGroup row">
            <label>{curType}자</label>

            <div className="field full">
              <input type="text" className="input md round_10" value={userName} disabled />
            </div>
          </div>

          {/* 작성/수정 일시 */}
          <div className="fieldGroup row">
            <label>{curType} 일시</label>

            <div className="field full">
              <input type="text" className="input md round_10" value={curDate} disabled />
            </div>
          </div>
        </fieldset>

        <div className="btnArea">
          {
            userScore >= curScore &&
            <button type="button" className="btn sm sfrtBlue round_10" onClick={() => NewsConfirm()}>{curType}{master === 1 ? '' : ' 요청'}</button>
          }
          <button type="button" className="btn sm blue_edge round_10" onClick={() => navigate('/admin/news/list')}>취소</button>
          {curType === '수정' && userScore >= 300 && <button type="button" className="btn sm red round_10" onClick={() => {if(window.confirm(`정말 해당 게시물을 삭제${master === 1 ? '' : ' 요청'}하시겠습니까?`)) deleteNews() }}>{`삭제${master === 1 ? '' : ' 요청'}`}</button>}
        </div>
      </div>
    </>
  )
}

export default AdNewsDt;